// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__3kf_R","gfeWrapper":"CalendarEvent_gfeWrapper__3dk65"};